import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { DateConvertor } from 'app/shared/common/helper/dateConvertor';
import { LazyLoadEvent, SelectItem } from 'primeng/primeng';
import { GetterSetter } from 'app/shared/common/helper/project';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ToastBaseModel } from 'app/shared/common/toast-data-model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SessionHandler } from 'app/shared/common/parse/session-handler';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { DatePipe } from '@angular/common';
import { ActivityCenterService } from 'app/shared/common/helper/activity-center';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';
import { DateServiceService } from 'app/shared/common/helper/dateservice';

@Component({
  selector: 'app-assigned-resources',
  templateUrl: './assigned-resources.component.html',
  styleUrls: ['./assigned-resources.component.scss']
})

export class AssignedResourcesComponent implements OnInit {

  @Input() projectId: any;
  @Input() projectType: any;
  empRole = '';
  objectId = '';
  totalAssignedResources: number;
  rowData = [];
  userIdArr = [];
  filterArray = [];
  selectedResource = [];
  totalResources: number;
  loadEventData: LazyLoadEvent;
  rowDatas = [];
  popupForm: FormGroup;
  userId: any;
  popupValue: any;
  selectedRows = [];
  resourceForm: FormGroup;
  cols1: any[];
  projectTypeOptions: SelectItem[];
  rollOptions: SelectItem[];
  deptOptions: SelectItem[];
  projectInformationForm: FormGroup;
  cols: any[];
  isEdit: boolean;
  locationDD = [];
  locationOptions: SelectItem[];
  deptDD = [];
  roleDD = [];
  rollOptions1: any[];
  resourcesLists = [];
  resourcesTypeLists = [];
  statusLists = [];
  reportingList = [];
  reportingToDD = [];
  reportingToOptions: SelectItem[];
  userCompareId = [];
  userIds = [];
  projetcDetails: any;
  roleOptions: any[];
  roles: any[];
  roleOptionsDD = [];
  totalCount = 0;
  reAssignResourcePopupForm: FormGroup;
  reassignSave = false;
  endDate: any;
  activity = [];
  projectValue: any;
  oldValueResource: any;
  currentUser = this.parseService.instance.User.current();
  currentValues: any;
  reAssignedResource: any;
  firstname: any;
  lastname: any;
  name: any;
  projectActivities: any;
  currentProjectDetails: any;
  newValues: any;
  username: any;
  typeOfProject: any;
  currentStatus: any;
  projectTypeCheck: any;
  oldReassignValue: any;
  currentUsername: string;
  @ViewChild('projectEditPopup', { static: false }) projectEditPopup: TemplateRef<any>;
  @ViewChild('projectDialog', { static: false }) projectDialog: TemplateRef<any>;
  @ViewChild('projectaddonDialog', { static: false }) projectaddonDialog: TemplateRef<any>;
  @ViewChild('reAssignResourcePopup', { static: false }) reAssignResourcePopup: TemplateRef<any>;
  tenantId: any;
  minDateForStartDate = new Date();
  isHours = false;
  editable = false;
  resourceCount: number;
  resourceTypeEdit: any;
  industryId: any;
  totalBillableCount: number;
  totalNonBillableCount: number;
  projectBillingType: string = '';

  constructor(
    public dialog: MatDialog,
    private toastr: ToastrService,
    private toastMessage: ToastBaseModel,
    private queryInterface: QueryInterface,
    private parseService: ParseService,
    private dateConvertor: DateConvertor,
    private route: ActivatedRoute,
    private projectInterface: GetterSetter,
    private formBuilder: FormBuilder,
    private sessionHandler: SessionHandler,
    private storageConfiguration: StorageConfiguration,
    private hardCodedValues: HardCodedValues,
    private activityCenterService: ActivityCenterService,
    private getReportingToService: GetReportingToService,
    private dateServiceService: DateServiceService
  ) {
    this.projectTypeOptions = [];
    this.industryId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.industryId);
    this.cols = [
      { header: 'S.No', field: 'position' },
      { header: 'Profile', field: 'profile' },
      { header: 'Name', field: 'username' },
      { header: 'Email', field: 'email' },
      // { header: 'Designation', field: 'designation' },
      { header: 'Role', field: 'role' },
      { header: 'Resource Type', field: 'resourceType' },
      // { header: 'Start Date', field: 'startDate' },
      // { header: 'End Date', field: 'endDate' },
      // { header: 'Status', field: 'status' },
    ];

    this.cols1 = [
      { header: 'Profile', field: 'profile' },
      { header: 'Name', field: 'userName' },
      { header: 'Email', field: 'officialEmail' },
      // { header: 'Department', field: 'department' },
      { header: 'Role', field: 'role' },
      // { header: 'Start Date', field: 'startDate' },
      // { header: 'Resource Type', field: 'resourceType' },
      { header: 'Billing Type', field: 'isBillable' },
    ];

    this.resourcesTypeLists = [
      { value: 'Dedicated-Billable', viewValue: 'Dedicated-Billable' },
      { value: 'Dedicated Non-Billable', viewValue: 'Dedicated Non-Billable' },
      { label: 'Fixed-Billable', value: 'Fixed-Billable' },
      { label: 'Fixed Non-Billable', value: 'Fixed Non-Billable' },
      { value: 'Dedicated Proxy', viewValue: 'Dedicated Proxy' },
      { value: 'Bench', viewValue: 'Bench' },
      { value: 'Trainee', viewValue: 'Trainee' },
      { label: 'Support-Billable', value: 'Support-Billable' },
      { label: 'Support Non-Billable', value: 'Support Non-Billable' },
      { value: 'Training', viewValue: 'Training' }
    ];

    this.reAssignResourcePopupForm = this.formBuilder.group({
      name: ['', Validators.required],
      // startDate: ['', Validators.required],
      // endDate: ['', Validators.required],
      resourceType: ['', Validators.required],
      userId: [, Validators.required],
      projectId: ['', Validators.required],
      isActive: ['', Validators.required],
      status: ['', Validators.required],
      role: ['', Validators.required],
      // hours: [],
      // months: []
    });

  }

  /*
  ** ==========================================================
  ** On Init
  ** ==========================================================
  */
  async ngOnInit() {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.firstname = this.parseService.instance.User.current().get('firstName');
    this.lastname = this.parseService.instance.User.current().get('lastName');
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.route.params.subscribe(params => {
      this.objectId = params['id'];
      if (this.objectId != '' && this.objectId != undefined) {
        this.isEdit = true;
      }
    });

    if (this.projectId != '' && this.projectId != undefined) {
      this.objectId = this.projectId;
    }
    let condition = [{ condition: 'equalTo', field: 'objectId', value: this.objectId }];
    await this.queryInterface.executeQuery(this.parseService, 'Project', condition).then(results => {
      let result = results[0];
      let projectInfo = result.get('projectInfo').currentStatus;
      this.projectBillingType = result.get('projectInfo').projectType;
      this.currentStatus = projectInfo;

      this.projectTypeCheck = result.get('projectType');
    });

    this.getLeadersProjectId();
    this.popupForm = this.formBuilder.group({
      isBillable: ['', Validators.required],
      username: ['', Validators.required],
      popupStatus: ['', Validators.required],
      popupRole: ['', Validators.required],
      hours: [''],
      months: [''],
    });

    this.resourceForm = this.formBuilder.group({
      startdate: ['', Validators.required],
      resourcetype: ['', Validators.required],
    });

    // disable popup form if not admin
    if (this.empRole != 'Admin') {
      this.popupForm.disable();
    }

    this.getProjectInformation();
    this.getLocation();
    this.getDepartment();
    this.getRollOption();
    this.getAssignedResources();
    this.getDropDowns();
    this.getProject();
    this.getReportingTo();
    this.getEmployeeCount();
  }

  getEmployeeCount() {
    this.queryInterface.executeQuery(this.parseService, 'Profile', [
      { condition: 'equalTo', field: 'isActive', value: true },
      { condition: 'equalTo', field: 'tenantId', value: this.tenantId },]).then(results => {
        this.resourceCount = results.length;
      }).catch(err => {
        this.sessionHandler.handleParseError(err);
      });
  }

  /*
  ** ==========================================================
  ** Get Project
  ** ==========================================================
  */
  getProject() {
    let id = '';
    id = this.empRole == 'Admin' ? this.objectId : this.projectId ? this.projectId : this.objectId;
    this.queryInterface.executeQuery(this.parseService, 'Project', [
      { condition: 'equalTo', field: 'objectId', value: id }]).then(result => {
        this.projetcDetails = result[0];
        this.activity = this.projetcDetails.get('activities') == undefined ? [] : this.projetcDetails.get('activities');
        this.endDate = this.projetcDetails.get('projectInfo').actualCompletionDate;
        let resourcesDetails = this.projetcDetails.get('resourceDetails').details;
        this.totalCount = 0;
        this.isHours = this.projetcDetails.attributes.schedulerStatus === 'Fixed Billable' || this.projetcDetails.attributes.schedulerStatus === 'Fixed Non-Billable' ? true : false;
        if (this.isHours === true) {
          this.cols.push({ header: 'Hours', field: 'hours' },
            { header: 'Action', field: 'action' },
          );

        }
        else {
          this.cols.push({ header: 'Months', field: 'months' },
            { header: 'Action', field: 'action' },
          );
        }
        if (this.isHours) {
          this.cols1.push({ header: 'Hours', field: 'hours' });

        }
        else {
          this.cols1.push({ header: 'Months', field: 'months' });
        }


        resourcesDetails.forEach(element => {
          this.totalCount += element.count;
        });
        /**
         * roleDrop was used before
         */
        this.roleDrop();
      });
  }


  async getLeadersProjectId() {
    if (this.empRole != 'Admin') {
      this.queryInterface.executeQuery(this.parseService, 'ProjectMembers',
        [
          { condition: 'include', value: 'client' },
          { condition: 'include', value: 'project' },
          { condition: 'include', value: 'project.client' },
          { condition: 'equalTo', field: 'project', value: { __type: 'Pointer', className: 'Project', objectId: this.objectId } }]
      ).then(results => {
        var result = results[0];
        var Finalres = result.get('project');
        this.projectId = Finalres.id;
        this.getAssignedResources();
      }
      );
    }
  }

  /*
  ** ==========================================================
  ** Get Office Locations
  ** ==========================================================
  */
  async getLocation() {
    await this.getReportingToService.getLocation().then(res => {
      this.locationOptions = res;
    });
  }

  /*
  ** ==========================================================
  ** Get Department Details
  ** ==========================================================
  */
  async getDepartment() {
    await this.getReportingToService.getDepartment().then(res => {
      this.deptOptions = res;
    });
  }

  /*
  ** ==========================================================
  ** Get role details
  ** ==========================================================
  */
  getRollOption() {
    let result = [];
    let resultDD = [];
    this.queryInterface.queryRoleAll(this.parseService).then(results => {
      for (let i = 0; i < results.length; i++) {
        let jsonText = JSON.stringify(results[i]);
        let roleList = JSON.parse(jsonText);
        result.push({ name: roleList.name, id: roleList.objectId });
        resultDD.push(roleList.name);
      }
      this.roleDD = result;
      this.rollOptions = this.bindDropDown(this.roleDD);
      this.rollOptions1 = this.bindRoleDropDown(resultDD);
    });
  }

  /*
  ** ==========================================================
  ** Bind dropdown
  ** ==========================================================
  */
  bindDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a.name, value: a.id });
    });
    return dropDownItem;
  }

  bindRoleDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a, value: a });
    });
    return dropDownItem;
  }

  /*
  ** ==========================================================
  ** Get project informations
  ** ==========================================================
  */
  getProjectInformation() {
    let condition = [];
    let type = '';
    if (this.empRole == 'Admin') {
      condition = [
        { condition: 'equalTo', field: 'objectId', value: this.objectId },
        { condition: 'include', value: 'client' }
      ];
      type = 'Project';
    } else {
      condition = [
        { condition: 'include', value: 'project' },
        { condition: 'include', value: 'project.client' },
        { condition: 'include', value: 'user' },
        { condition: 'equalTo', field: 'project', value: { __type: 'Pointer', className: 'Project', objectId: this.objectId } }
      ];
      type = 'ProjectMembers';
    }
    this.queryInterface.executeQuery(this.parseService, type, condition).then(results => {
      const result = results[0];
      if (this.empRole == 'Admin') {
        this.projectValue = this.projectInterface.getProject(result);
        this.typeOfProject = this.projectValue.projectInfo.addOnType;
        this.getDropDowns();
        this.projectId = result.id;
      } else {
        this.projectValue = this.projectInterface.getProject(result.get('project'));
        this.currentProjectDetails = this.projectValue;
        this.typeOfProject = this.projectValue.projectInfo.addOnType;
        this.getDropDowns();
      }
    });
  }

  /*
  ** ==========================================================
  ** Get dropdown values
  ** ==========================================================
  */
  async getDropDowns() {
    this.statusLists = [];
    this.resourcesLists = [];
    this.projectTypeOptions = [];
    this.statusLists.push(
      { value: 'Assigned', viewValue: 'Assigned' },
      { value: 'Released', viewValue: 'Released' }
    );

    // if (this.typeOfProject != 'Support' && this.typeOfProject != 'Task') {
    // if (this.projectType == 'Fixed') {
    //   this.resourcesLists.push({ value: 'Fixed-Billable', viewValue: 'Fixed-Billable' },
    //     { value: 'Fixed Non-Billable', viewValue: 'Fixed Non-Billable' },
    //     { value: 'Bench', viewValue: 'Bench' },
    //     { value: 'Trainee', viewValue: 'Trainee' });

    //   this.projectTypeOptions.push({ label: 'Fixed-Billable', value: 'Fixed-Billable' },
    //     { label: 'Fixed Non-Billable', value: 'Fixed Non-Billable' },
    //     { label: 'Bench', value: 'Bench' },
    //     { label: 'Trainee', value: 'Trainee' });
    // }
    // if (this.projectType == 'Dedicated') {
    //   this.resourcesLists.push({ value: 'Dedicated-Billable', viewValue: 'Dedicated-Billable' },
    //     { value: 'Dedicated Non-Billable', viewValue: 'Dedicated Non-Billable' },
    //     { value: 'Dedicated Proxy', viewValue: 'Dedicated Proxy' },
    //     { value: 'Bench', viewValue: 'Bench' },
    //     { value: 'Trainee', viewValue: 'Trainee' });

    //   this.projectTypeOptions = [
    //     { label: 'Dedicated Non-Billable', value: 'Dedicated Non-Billable' },
    //     { label: 'Dedicated-Billable', value: 'Dedicated-Billable' },
    //     { label: 'Dedicated Proxy', value: 'Dedicated Proxy' },
    //     { label: 'Bench', value: 'Bench' },
    //     { label: 'Trainee', value: 'Trainee' }];
    // }

    // }
    if (this.typeOfProject != 'Support' && this.typeOfProject != 'Task') {
      if (this.projectType == 'Fixed Billable') {
        this.resourcesLists.push({ value: 'Fixed-Billable', viewValue: 'Fixed-Billable' },
          { value: 'Bench', viewValue: 'Bench' },
          { value: 'Trainee', viewValue: 'Trainee' });

        this.projectTypeOptions.push({ label: 'Fixed-Billable', value: 'Fixed-Billable' },
          { label: 'Bench', value: 'Bench' },
          { label: 'Trainee', value: 'Trainee' });
      }
      if (this.projectType == 'Fixed Non-Billable') {
        this.resourcesLists.push({ value: 'Fixed Non-Billable', viewValue: 'Fixed Non-Billable' },
          { value: 'Bench', viewValue: 'Bench' },
          { value: 'Trainee', viewValue: 'Trainee' });

        this.projectTypeOptions.push({ label: 'Fixed Non-Billable', value: 'Fixed Non-Billable' },
          { label: 'Bench', value: 'Bench' },
          { label: 'Trainee', value: 'Trainee' });
      }
      if (this.projectType == 'Time and Material Billable') {
        this.resourcesLists.push({ value: 'Time and Material Billable', viewValue: 'Time and Material Billable' },
          { value: 'Bench', viewValue: 'Bench' },
          { value: 'Trainee', viewValue: 'Trainee' });

        this.projectTypeOptions.push({ label: 'Time and Material Billable', value: 'Time and Material Billable' },
          { label: 'Bench', value: 'Bench' },
          { label: 'Trainee', value: 'Trainee' });
      }
      if (this.projectType == 'Time and Material Non-Billable') {
        this.resourcesLists.push({ value: 'Time and Material Non-Billable', viewValue: 'Time and Material Non-Billable' },
          { value: 'Bench', viewValue: 'Bench' },
          { value: 'Trainee', viewValue: 'Trainee' });

        this.projectTypeOptions.push({ label: 'Time and Material Non-Billable', value: 'Time and Material Non-Billable' },
          { label: 'Bench', value: 'Bench' },
          { label: 'Trainee', value: 'Trainee' });
      }
    }

    if (this.typeOfProject == 'Support') {
      this.resourcesLists.push({ value: 'Support-Billable', viewValue: 'Support-Billable' },
        { value: 'Support Non-Billable', viewValue: 'Support Non-Billable' });

      this.projectTypeOptions = [
        { label: 'Support-Billable', value: 'Support-Billable' },
        { label: 'Support Non-Billable', value: 'Support Non-Billable' }];
    }
    if (this.typeOfProject == 'Task') {
      this.resourcesLists.push({ value: 'Training', viewValue: 'Training' });
      this.projectTypeOptions.push({ label: 'Training', value: 'Training' });
    }
  }

  /*
  ** ==========================================================
  ** Get project details
  ** ==========================================================
  */
  async getEmployeesProject() {
    this.roleDropChange();
    this.totalResources = await this.getResourcesCount();
    this.queryInterface.executeQuery(this.parseService, 'Profile', [
      { condition: 'equalTo', field: 'isActive', value: true },
      { condition: 'include', value: 'location' },
      { condition: 'include', value: 'reportingTo' },
      { condition: 'include', value: 'department' },
      { condition: 'include', value: 'role' },
      { condition: 'ascending', value: 'firstName' },
      { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
      { condition: 'limit', value: 10 },
      { condition: 'notContainedIn', field: 'objectId', value: this.userIds }]).then(results => {
        this.rowDatas = this.loadResources(results);
      }).catch(err => {
        this.sessionHandler.handleParseError(err);
      });
  }

  /*
  ** ==========================================================
  ** Get resource count
  ** ==========================================================
  */
  async getResourcesCount() {
    return this.queryInterface.getQueryCount(this.parseService, 'Profile', [
      { condition: 'equalTo', field: 'isActive', value: true },
      { condition: 'include', value: 'location' },
      { condition: 'include', value: 'reportingTo' },
      { condition: 'include', value: 'department' },
      { condition: 'include', value: 'role' },
      { condition: 'ascending', value: 'firstName' },
      { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
    ]);
  }

  /*
  ** ==========================================================
  ** Get reporting to details
  ** ==========================================================
  */
  async getReportingTo() {
    await this.getReportingToService.getReportingTo().then(res => {
      this.reportingToOptions = res;
    });
  }

  uniqBy(a, key) {
    var index = [];
    return a.filter(function (item) {
      var k = key(item);
      return index.indexOf(k) >= 0 ? false : index.push(k);
    });
  }

  resourcesDelete(resource) {
    this.selectedResource.splice(this.selectedResource.findIndex(x => x == resource), 1);
    if (this.selectedResource.length == 0) {
      this.dialog.closeAll();
    }
  }

  /*
  ** ==========================================================
  ** Get assigned resource details
  ** ==========================================================
  */
  async getAssignedResources() {
    let id = '';
    if (this.empRole == 'Admin') {
      id = this.objectId;
    } else if (this.empRole != 'Admin') {
      id = this.projectId;
    }
    this.totalAssignedResources = await this.getCount('Assigned');
    this.queryInterface.executeQuery(this.parseService, 'ProjectMembers', [
      { condition: 'equalTo', field: 'project', value: { __type: 'Pointer', className: 'Project', objectId: id } },
      { condition: 'equalTo', field: 'isActive', value: true },
      { condition: 'equalTo', field: 'status', value: 'Assigned' },
      { condition: 'include', value: 'user' },
      { condition: 'include', value: 'project' },
      { condition: 'include', value: 'user.profile' },
      { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
      { condition: 'ascending', value: 'username' }]).then(results => {
        results.forEach((element, index) => {
          let userObject = element.get('user');
          let profile = userObject.get('profile');
          this.userCompareId = profile.id;
          this.userIds.push(this.userCompareId);
        });
        this.rowData = this.loadValue(results, 0);
      });
  }

  /*
  ** ==========================================================
  ** Get resource count
  ** ==========================================================
  */
  getCount(type) {
    let id = '';
    if (this.empRole == 'Admin') {
      id = this.objectId;
    } else if (this.empRole != 'Admin') {
      id = this.projectId;
    }
    return this.queryInterface.getQueryCount(this.parseService, 'ProjectMembers', [
      { condition: 'equalTo', field: 'project', value: { __type: 'Pointer', className: 'Project', objectId: id } },
      { condition: 'equalTo', field: 'isActive', value: true },
      { condition: 'equalTo', field: 'status', value: type },
      { condition: 'include', value: 'profile' },
      { condition: 'include', value: 'profile.role' }
    ]);
  }

  /*
  ** ==========================================================
  ** Assigned resource details
  ** ==========================================================
  */
  loadValue(results, skip) {
    let i = skip;
    let result = [];
    results.forEach((element, index) => {
      i = i + 1;
      this.totalBillableCount = 0;
      this.totalNonBillableCount = 0;

      let userObject = element.get('user');
      let profile = userObject.get('profile');
      this.userIdArr.push(element);
      let roleObj = profile.get('role');
      let emailObj = profile.get('officialInfo');
      let jsonText = JSON.stringify(element);
      let userRole = JSON.parse(jsonText);
      let hours = element.attributes.Hours;
      let months = element.attributes.Month;


      let billableInfo = userRole.isBillable ? 'Billable' : 'Non-Billable';
      if (billableInfo) { this.totalBillableCount = this.totalBillableCount + 1 }
      else { this.totalNonBillableCount = this.totalNonBillableCount + 1 }

      let profileImage = element.get('user').get('profile').get('profileImageInfo').url;
      if (!profileImage) {
        profileImage = '../../../../../../../../assets/images/avatars/profile.jpg';
      }
      result.push({
        objectId: userRole.objectId,
        position: i,
        username: profile.get('firstName') + ' ' + profile.get('lastName'),
        startDate: this.dateConvertor.momentChange(userRole.startDate.iso),
        endDate: this.dateConvertor.momentChange(userRole.endDate.iso),
        resourceType: userRole.isBillable ? 'Billable' : 'Non-Billable',
        status: userRole.status,
        months: months,
        hours: hours,
        profile: profileImage,
        email: emailObj.officialEmail,
        isBillable: userRole.isBillable,
        designation: roleObj.get('name'),
        role: element.get('role') == undefined ? '' : element.get('role'),
        action: ''
      });
    });
    return result;
  }

  onChangeEvent(event, resourceName) {
    this.selectedResource.forEach(element => {
      if (element.id == resourceName) {
        element.startDate = this.dateConvertor.addGMTOffset(event.value);
      }
    });
  }

  dateChange(event) {
    return this.dateConvertor.addGMTOffset(event.value);
  }

  /*
  ** ==========================================================
  ** Lazy load
  ** ==========================================================
  */
  async onLazyLoadAddResources(event: LazyLoadEvent) {
    this.selectedRows = [];
    this.loadEventData = event;
    let condition = [];
    condition = [
      { condition: 'equalTo', field: 'isActive', value: true },
      { condition: 'include', value: 'location' },
      { condition: 'include', value: 'reportingTo' },
      { condition: 'include', value: 'department' },
      { condition: 'include', value: 'role' },
      { condition: 'ascending', value: 'firstName' },
      { condition: 'equalTo', field: 'tenantId', value: this.tenantId }
    ];

    const filter: any = event.filters;
    if (!filter) {
      const skip: number = event.first;
      if (this.userIds.length > 0) {
        condition.push({ condition: 'notContainedIn', field: 'objectId', value: this.userIds });
      }
      this.totalResources = await this.getTotalRecordsCount(condition);
      this.lazyLoadAddResources(condition, skip, event.rows);

    } else if (event.sortField) {
      const skip: number = event.first;

      let field = event.sortField;
      let sortOrder = event.sortOrder == 1 ? 'descending' : 'ascending';

      // tslint:disable-next-line: forin
      for (let key in filter) {
        let query = filter[key].value;
        if (key == 'reportingTo' || key == 'role' || key == 'location' || key == 'department') {
          condition.push({ condition: 'containedIn', field: key, value: filter[key].value });
        } else {

          if (key != 'officialInfo.officialEmail') {
            filter[key].value = filter[key].value.replace(/\b\w/g, l => l.toUpperCase());
          }
          condition.push({ condition: 'contains', field: key, value: filter[key].value });
        }
      }
      let sortCondition = {};
      if (sortOrder == 'ascending') {
        sortCondition = { condition: sortOrder, value: field };
      } else {
        sortCondition = { condition: sortOrder, field: field };
      }
      this.totalResources = await this.getTotalRecordsCount(condition);
      if (this.totalResources < event.first) {
        event.first = 0;
      }
      condition.push(sortCondition);
      this.lazyLoadAddResources(condition, skip, event.rows);
    } else {
      if (this.userIds.length > 0) {
        condition.push({ condition: 'notContainedIn', field: 'objectId', value: this.userIds });
      }
      // tslint:disable-next-line: forin
      for (let key in filter) {
        let query = filter[key].value;

        if (key == 'reportingTo' || key == 'role' || key == 'location' || key == 'department') {
          condition.push({ condition: 'containedIn', field: key, value: filter[key].value });
        } else {
          if (key != 'officialInfo.officialEmail') {
            filter[key].value = filter[key].value.replace(/\b\w/g, l => l.toUpperCase());
          }
          condition.push({ condition: 'contains', field: key, value: filter[key].value });
        }
      }

      this.totalResources = await this.getTotalRecordsCount(condition);
      if (this.totalResources < event.first) {
        event.first = 0;
      }
      this.lazyLoadAddResources(condition, event.first, event.rows);
    }

  }
  getTotalRecordsCount(condition) {
    return this.queryInterface.getQueryCount(this.parseService, 'Profile', condition);
  }

  lazyLoadAddResources(condition, skip, limit) {
    condition.push({ condition: 'skip', value: skip }, { condition: 'limit', value: limit });
    this.queryInterface.executeQuery(this.parseService, 'Profile', condition).then(results => {
      this.rowDatas = this.loadResources(results);
    });
  }

  // async getIndustryDepartment(): Promise<void> {
  //   this.roleOptions = [];
  //   const IndustryRoleClass = this.parseService.instance.Object.extend('IndustryRole');
  //   const industryRoleQuery = new this.parseService.instance.Query(IndustryRoleClass);
  //   industryRoleQuery.include('masterRoleIds');
  //   industryRoleQuery.include('roleIds');
  //   industryRoleQuery.equalTo('industryId', {
  //     __type: 'Pointer',
  //     className: 'Industry',
  //     objectId: this.industryId,
  //   });
  //   let industryRoleData = await industryRoleQuery.find();
  //   industryRoleData = industryRoleData[0].attributes.departmentNames;
  //   for (const data of industryRoleData) {
  //     this.roleOptions.push(data);
  //   }
  //   this.roles = this.roleOptions;
  //   this.roleOptionsDD = this.bindRoleDropDown(this.roleOptions);
  // }

  async roleDrop() {
    this.roleOptions = [];
    const TenantDepartment = this.parseService.instance.Object.extend('TenantDepartment');
    const tenantDepartment = new this.parseService.instance.Query(TenantDepartment);
    tenantDepartment.equalTo('tenantId', this.tenantId);
    let industryRoleData = await tenantDepartment.find();
    if (industryRoleData.length > 0) {
      for (let data of industryRoleData) {
        this.roleOptions.push(data.get('displayName'))
      }
      this.roles = this.roleOptions;
      this.roleOptionsDD = this.bindRoleDropDown(this.roleOptions);
    }
    else {
      let queryInstance = this.parseService.instance.Object.extend('DataSettings');
      let query = new this.parseService.instance.Query(queryInstance);
      let results = await query.find();
      let role = results[0].attributes.resourceRole;
      for (let data of role) {
        this.roleOptions.push(data);
      }
      this.roles = this.roleOptions;
      this.roleOptionsDD = this.bindRoleDropDown(this.roleOptions);
    }
  }

  /*
  ** ==========================================================
  ** Resource Details
  ** ==========================================================
  */
  loadResources(results) {
    this.selectedResource = [];
    let result = [];
    this.filterArray.forEach(item2 => {
      results = results.filter(item1 => {
        return JSON.stringify(item1) !== JSON.stringify(item2);
      });
    });
    results.forEach((element, index) => {
      let rolePoint = element.get('role');
      let locationPoint = element.get('location');
      let reportingPoint = element.get('reportingTo');
      let officialInfo = element.get('officialInfo');
      let departmentPoint = element.get('department');
      let profileImage = element.get('profileImageInfo').url;
      if (!profileImage) {
        profileImage = '../../../../../../../../assets/images/avatars/profile.jpg';
      }
      result.push({
        position: index + 1,
        userName: element.get('firstName') + ' ' + element.get('lastName'),
        officialEmail: officialInfo.officialEmail,
        designation: rolePoint.get('name'),
        department: departmentPoint.get('name'),
        location: locationPoint ? locationPoint.get('name') : '',
        reportingTo: reportingPoint.get('username'),
        objectId: element.id,
        profile: profileImage,
        role: '',
        hours: 0,
        months: 0,
        startDate: '',
        resourceType: '',
        isSelected: false,
        isBillable: '',
        action: ''
      });
    });
    return result;
  }

  selectChange(event) {
    this.rowDatas.forEach(element => {
      element.isSelected = false;

    });
    this.selectedRows.forEach(element => {
      element.isSelected = true;
    });
  }

  onResourceChange(events, resourceName) {
    this.selectedResource.forEach(element => {
      if (element.id == resourceName) {
        element.resourceType = events.value;
      }
    });
  }

  /*
  ** ==========================================================
  ** Add Resource
  ** ==========================================================
  */
  async addRow() {
    let roleValid = this.selectedResource.filter(a => a.role == '');

    if (roleValid.length > 0) {
      this.toastr.warning('Please enter the required fields');
      return false;
    }

    if (this.isHours) {
      let isHourEmpty = this.selectedResource.filter(b => b.hours == '');
      if (isHourEmpty.length > 0) {
        return this.toastr.warning('Enter the valid hours');
      }
    }

    if (!this.isHours) {
      let isMonthEmpty = this.selectedResource.filter(b => b.months == '');
      if (isMonthEmpty.length > 0) {
        return this.toastr.warning('Once a month at least');
      }
    }

    let rowAdd = true;
    this.totalCount = 0;
    let resourcesDetails = this.projetcDetails.get('resourceDetails').details;
    resourcesDetails.forEach(element => {
      this.totalCount += element.count;
    });

    // this.roleOptions.forEach(element => {
    //   let roleByMember = this.rowData.filter(a => a.role == element);
    //   let resourcesDet = resourcesDetails.filter(s => s.role == element);
    //   let resourceCount = resourcesDet[0].count;
    //   let selectCount = this.selectedResource.filter(s => s.role == element);

    //   if ((roleByMember.length + selectCount.length) > resourceCount) {
    //     this.toastr.warning(element + ' Resource Limit is reached');
    //     rowAdd = false;
    //   }
    // });

    if (rowAdd) {
      this.selectedResource.forEach(element => {

        // if (this.projectBillingType == 'Time and Material Non-Billable' || this.projectBillingType == 'Fixed Non-Billable') {
        //   if (!element.isBillable) {
        //     return this.toastr.warning('The project is in non-billing status, so cannot assign billable resources!!')
        //   }
        // }

        let userId;
        this.queryInterface.executeQuery(this.parseService, 'User', [
          { condition: 'equalTo', field: 'profile', value: { __type: 'Pointer', className: 'Profile', objectId: element.userId.id == undefined ? element.userId : element.userId.id } },
          { condition: 'include', value: 'profile' }]).then(results => {
            let project = element;
            let result = results[0];
            userId = result.id;
            let newValue = JSON.parse(JSON.stringify(project));

            let ProjectClass = this.parseService.instance.Object.extend('ProjectMembers');
            var projectDetails = new ProjectClass();
            projectDetails.set('project', project.projectId);
            projectDetails.set('startDate', new Date());
            projectDetails.set('endDate', new Date());
            // projectDetails.set('resourcesType', this.projetcDetails.attributes.schedulerStatus);
            projectDetails.set('resourcesType', project.resourcesType ? 'Billable' : 'Non-Billable');
            projectDetails.set('username', project.name);
            projectDetails.set('isActive', project.isActive);
            projectDetails.set('tenantId', this.tenantId);
            projectDetails.set('status', project.status);
            projectDetails.set('isInvited', true)
            projectDetails.set('role', project.role);
            projectDetails.set('user', { __type: 'Pointer', className: '_User', objectId: userId });
            projectDetails.set('Hours', project.hours ? project.hours : 0);
            projectDetails.set('Month', project.months ? project.months : 0);
            projectDetails.set('isBillable', element.isBillable);
            projectDetails.save().then(async result => {
              let activityNew = [];
              await this.getProjectMemberCount();
              this.currentUsername = project.name;
              // tslint:disable-next-line: max-line-length
              if (this.reassignSave) {
                let message = 'Re-Assigned a resource ' + this.reAssignedResource + ' to ' + project.name
                activityNew.push(this.setActivityModel(message));
                activityNew.forEach(element => {
                  this.activity.unshift(element);
                });
                this.getAssignedResources();
                this.reassignSave = false;

                let activities = this.getActivity(this.oldReassignValue, newValue);
                activities.forEach(element => {
                  this.activity.unshift(element);
                });
                if (this.projectTypeCheck == 'Project') {
                  this.activityCenterService.createActivity(activities, this.hardCodedValues.project, this.objectId);
                } else if (this.projectTypeCheck == 'Sub-Project') {
                  this.activityCenterService.createActivity(activities, this.hardCodedValues.addons, this.objectId);
                }
              } else {
                let message = 'Added a resource ' + result.get('username') + ' as ' + project.role + ' ' + project.resourceType;
                activityNew.push(this.setActivityModel(message));
                activityNew.forEach(element => {
                  this.activity.unshift(element);
                });
                this.getAssignedResources();
              }

              this.toastr.success('Resource Assigned Successfully!!');

              if (this.projectTypeCheck == 'Project') {
                this.activityCenterService.createActivity(activityNew, this.hardCodedValues.project, this.objectId);
              } else if (this.projectTypeCheck == 'Sub-Project') {
                this.activityCenterService.createActivity(activityNew, this.hardCodedValues.addons, this.objectId);
              }

              let id = '';
              id = this.empRole == 'Admin' ? this.objectId : this.projectId;

              this.queryInterface.executeQuery(this.parseService, 'Project', [
                { condition: 'equalTo', field: 'objectId', value: id }]).then(result => {
                  var results = result[0];
                  results.set('activities', this.activity);
                  results.save().then(res => {
                  });
                });
            });
          });
      });
      this.dialog.closeAll();
    }
  }

  async getProjectMemberCount() {
    let queryInstance = this.parseService.instance.Object.extend('ProjectMembers');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: this.objectId });
    query.equalTo('status', 'Assigned');
    query.equalTo('tenantId', this.tenantId);
    let projectMembersDetails = await query.find();
    if (projectMembersDetails.length > 0) {

      var billableCount: any = 0;
      var nonBillableCount: any = 0;

      for (let data of projectMembersDetails) {
        let isBillable = data.get('isBillable') ? data.get('isBillable') : false;
        if (isBillable) { billableCount = billableCount + 1; }
        else { nonBillableCount = nonBillableCount + 1; }
      }

      billableCount = billableCount;
      nonBillableCount = nonBillableCount;
      var totalBillableCount: any = Number(billableCount) + Number(nonBillableCount);

      let Project = this.parseService.instance.Object.extend('Project');
      let project = new this.parseService.instance.Query(Project);
      project.equalTo('objectId', this.objectId);
      let result = await project.find();
      let projectInfo = result[0];
      projectInfo.set('totalBillingCount', billableCount);
      projectInfo.set('totalNonBillingCount', nonBillableCount);
      projectInfo.set('totalAssigneeCount', totalBillableCount);
      let projectDetails = await projectInfo.save();
    }
  }

  /*
  ** ==========================================================
  ** Get Activities
  ** ==========================================================
  */
  getActivity(oldValue, newValue): any[] {

    const activities = [];
    // tslint:disable-next-line: forin
    for (const oldproperty in oldValue) {
      for (const newproperty in newValue) {
        if (oldproperty === newproperty) {
          let activityModel = this.createActivity(oldproperty, oldValue[oldproperty], newValue[newproperty]);

          if (activityModel.allow) {
            if (activityModel.type === 'Array') {
              activityModel.activity.forEach(element => {
                activities.push(element);
              });

            } else {
              activities.push(activityModel.activity);
            }

          }
        }
      }
    }
    return activities;
  }

  /*
  ** ==========================================================
  ** Create activities
  ** ==========================================================
  */
  createActivity(property, oldValue, newValue): any {
    let message = '';
    let messages = [];
    let activity = {};
    let allow = false;

    const type = this.typeCheck((property === 'startdate1' || property === 'enddate1') ? newValue._d : newValue);
    switch (type) {
      case 'string':
        if (oldValue !== newValue) {
          switch (property) {
            case 'popupRole':
              const oldRole = oldValue !== '' ? this.roleOptionsDD.filter(x => x.value === oldValue) : '';
              const newRole = this.roleOptionsDD.filter(x => x.value === newValue);
              // tslint:disable-next-line: max-line-length
              message = oldRole === '' ? 'Added a Role - ' + newRole[0].value + ' - Resource Name - ' + this.username : 'Changed ' + this.username + ' role from ' + oldRole[0].value + ' to ' + newRole[0].value;
              allow = true;
              break;

            case 'popupResourcesType':
              const oldResourceType = oldValue !== '' ? this.resourcesTypeLists.filter(x => x.value === oldValue) : '';
              const newResourceType = this.resourcesTypeLists.filter(x => x.value === newValue);
              // tslint:disable-next-line: max-line-length
              message = oldResourceType === '' ? 'Added a Resource Type - ' + newResourceType[0].value + ' - Resource Name - ' + this.username : 'Changed resource type from ' + oldResourceType[0].value + ' to ' + newResourceType[0].value + ' - Resource Name - ' + this.username;
              allow = true;
              break;

            case 'startDate':
              let prop = this.hardCodedValues.getValues(property);

              const datePipe1 = new DatePipe('en-US');
              const oldDate1 = datePipe1.transform(oldValue, 'MMM dd yyyy');
              const newDate1 = datePipe1.transform(newValue, 'MMM dd yyyy');
              if (oldDate1 !== newDate1) {
                // tslint:disable-next-line: max-line-length
                message = oldValue === '' ? 'Added a ' + prop + ' - Resource Name - ' + this.currentUsername : 'Updated the ' + prop + ' from ' + oldDate1 + ' to ' + newDate1 + ' - Resource Name - ' + this.currentUsername;
                allow = true;
              }
              break;

            case 'endDate':
              let prop2 = this.hardCodedValues.getValues(property);

              const datePipe = new DatePipe('en-US');
              const oldDate = datePipe.transform(oldValue, 'MMM dd yyyy');
              const newDate = datePipe.transform(newValue, 'MMM dd yyyy');
              if (oldDate !== newDate) {
                // tslint:disable-next-line: max-line-length
                message = oldValue === '' ? 'Added a ' + prop2 + ' - Resource Name - ' + this.currentUsername : 'Updated the ' + prop2 + ' from ' + oldDate + ' to ' + newDate + ' - Resource Name - ' + this.currentUsername;
                allow = true;
              }
              break;

            case 'popupStatus':
              message = 'Released a Resource' + ' ' + this.username;
              allow = true;
          }
        }
        break;

      case 'Date':

        let prop = this.hardCodedValues.getValues(property);

        const datePipe = new DatePipe('en-US');
        const oldDate = datePipe.transform(oldValue, 'MMM dd yyyy');
        const newDate = datePipe.transform(newValue._d, 'MMM dd yyyy');
        if (oldDate !== newDate) {
          // tslint:disable-next-line: max-line-length
          message = oldValue === '' ? 'Added a ' + prop + ' - Resource Name - ' + this.username : 'Updated the ' + prop + ' from ' + oldDate + ' to ' + newDate + ' - Resource Name - ' + this.username;
          allow = true;
        }
        break;
    }

    if (type === 'Array') {
      let act = [];
      messages.forEach(element => {
        act.push(this.setActivityModel(element));
      });
      activity = act;
      return { activity: activity, allow, type };
    } else {
      activity = this.setActivityModel(message);
      return { activity: activity, allow, type };
    }
  }

  typeCheck(Source): string {
    if (Source != null) {
      if (Source.constructor === Array) {
        return 'Array';
      } else if (Source.constructor === Object) {
        return 'object';
      } else if (Source.constructor === String) {
        return 'string';
      } else if (Source.constructor === Date) {
        return 'Date';
      } else if (Source.constructor === Number) {
        return 'Number';
      }
    }
  }

  public async popupAdd(reassign) {

    // check if user is admin
    if (this.empRole != 'Admin') {
      this.toastr.warning('You are not authorized to perform this action on this resource contact Admin');
      return
    }
    
    if (this.popupForm.invalid) {
      return this.toastr.warning('Please enter the  required fields');
    }

    else {
      if (this.resourceTypeEdit == "Fixed Billable" && this.popupForm.value.hours == "0" && this.isHours && this.popupForm.value.popupStatus != "Released") {
        this.toastr.warning('Please enter the hours');
        return this.popupForm.invalid;
      }
      // if (this.resourceTypeEdit == "Fixed Billable" && this.popupForm.value.hours < "8") {
      //   return this.toastr.warning('Hours should be minium of 8');
      // }
      if (this.resourceTypeEdit == "Fixed Non-Billable" && this.popupForm.value.hours == "0" && this.isHours && this.popupForm.value.popupStatus != "Released") {
        this.toastr.warning('Please enter the hours');
        return this.popupForm.invalid;
      }
      // if (this.resourceTypeEdit == "Fixed Non-Billable" && this.popupForm.value.hours < "8") {
      //   return this.toastr.warning('Hours should be minium of 8');
      // }

      if (this.resourceTypeEdit == "Time and Material Billable" && this.popupForm.value.months == "0" && !this.isHours && this.popupForm.value.popupStatus != "Released") {
        this.toastr.warning('Please enter the month');
        return this.popupForm.invalid;
      }
      // if (this.resourceTypeEdit == "Time and Material Billable" && this.popupForm.value.months > "720") {
      //   return this.toastr.warning('Months should be minium of 30 days');
      // }

      if (this.resourceTypeEdit == "Time and Material Non-Billable" && this.popupForm.value.months == "0" && !this.isHours && this.popupForm.value.popupStatus != "Released") {
        this.toastr.warning('Please enter the month');
        return this.popupForm.invalid;
      }
      // if (this.resourceTypeEdit == "Time and Material Non-Billable" && this.popupForm.value.months > "720") {
      //   return this.toastr.warning('Months should be minium of 30 days');
      // }

      let projectValues = this.popupForm.value;
      let newValues = this.popupForm.value;
      let projectInfo;
      this.totalCount = 0;
      let rowAdd = true;

      let formControls = this.popupForm.controls;
      let resourcesDetails = this.projetcDetails.get('resourceDetails').details;
      resourcesDetails.forEach(element => {
        this.totalCount += element.count;
      });

      // if (formControls.popupRole.dirty) {
      //   let roleByMember = this.rowData.filter(a => a.role == projectValues.popupRole);
      //   let resourcesDet = resourcesDetails.filter(s => s.role == projectValues.popupRole);
      //   let resourceCount = resourcesDet[0].count;
      //   if ((roleByMember.length + 1) > resourceCount) {
      //     this.toastr.warning(projectValues.popupRole + ' Resource Limit is reached');
      //     rowAdd = false;
      //   }
      // }

      if (reassign) {
        projectInfo = {
          enddate1: this.dateConvertor.addGMTOffset(new Date()),
          popupStatus: 'Released',
        };
        rowAdd = true;
      } else {
        projectInfo = {
          // enddate1: new Date(),
          // startdate1: new Date(),
          hours: projectValues.hours ? projectValues.hours : 0,
          months: projectValues.months ? projectValues.months : 0,
          popupStatus: projectValues.popupStatus,
          role: projectValues.popupRole,
          resourceType: projectValues.popupResourcesType,
          isBillable: projectValues.isBillable,
        };
      }

      if (rowAdd) {
        this.projectInterface.updateProjectMember(this.userId, projectInfo);
        this.queryInterface.executeQuery(this.parseService, 'ProjectMembers', [
          { condition: 'equalTo', field: 'objectId', value: this.userId }]).then(result => {
            var results = result[0];
            // results.set('startDate', projectInfo.startdate1);
            // results.set('endDate', projectInfo.enddate1);
            results.set('Hours', Number(projectInfo.hours ? projectInfo.hours : 0));
            results.set('Month', Number(projectInfo.months ? projectInfo.months : 0));
            results.set('status', projectInfo.popupStatus);
            results.set('role', projectValues.popupRole);
            results.set('resourcesType', projectInfo.resourceType);
            results.set('isBillable', projectInfo.isBillable);

            results.save().then(async res => {
              if (rowAdd && !reassign) {
                await this.getProjectMemberCount();
                this.toastr.success(this.toastMessage.Save);
              }

              if (reassign) {
                let activityNew = [];
                let currentUsername = this.firstname + ' ' + this.lastname;
                this.reAssignedResource = res.get('username')
                this.rowData.splice(this.rowData.findIndex(a => a.objectId == this.userId), 1);
                await this.addRow();
              }
              this.getAssignedResources();
              this.dialog.closeAll();

            });
          });
      }

      let activities = this.getActivity(this.currentValues, newValues);
      activities.forEach(element => {
        this.activity.unshift(element);
      });

      if (this.projectTypeCheck == 'Project') {
        this.activityCenterService.createActivity(activities, this.hardCodedValues.project, this.objectId);
      } else if (this.projectTypeCheck == 'Sub-Project') {
        this.activityCenterService.createActivity(activities, this.hardCodedValues.addons, this.objectId);
      }

      let id = '';
      id = this.empRole == 'Admin' ? this.objectId : this.projectId;

      this.queryInterface.executeQuery(this.parseService, 'Project', [{ condition: 'equalTo', field: 'objectId', value: id }]).then(result => {
        var results = result[0];
        results.set('activities', this.activity);
        results.save().then(res => {
        });
      });

    }



  }

  /*
  ** ==========================================================
  ** Edit assigned resource details
  ** ==========================================================
  */
  nameClick(event) {
    this.dialog.open(this.projectEditPopup);
    this.userId = event;
    this.queryInterface.executeQuery(this.parseService, 'ProjectMembers', [
      { condition: 'equalTo', field: 'objectId', value: this.userId }]).then(result => {
        var results = result[0];
        this.resourceTypeEdit = results.attributes.resourcesType;
        this.popupValue = this.projectInterface.getProjectMember(results);
        this.popupForm.patchValue({
          username: this.popupValue.username,
          // startdate1: this.popupValue.startDate,
          // enddate1: this.popupValue.endDate,
          popupStatus: this.popupValue.status,
          popupRole: this.popupValue.role,
          popupResourcesType: results.get('resourcesType'),
          hours: results.get('Hours'),
          months: results.get('Month'),
          isBillable: results.get('isBillable')
        });

        this.currentValues = this.popupForm.value;
        this.username = this.popupForm.value.username;
        this.oldValueResource = JSON.parse(JSON.stringify(this.popupForm.value));
      });
    this.userId = event;

  }

  addresources() {
    var selectedRow = this.selectedRows;
    this.selectedResource = [];
    this.roleDropChange();
    selectedRow.forEach(element => {
      var profile = new this.parseService.instance.Object('Profile');
      var project = new this.parseService.instance.Object('Project');
      if (this.empRole == 'Admin') {
        project.id = this.objectId;
      }
      if (this.empRole == 'Leader') {
        project.id = this.projectId == undefined ? this.objectId : this.projectId;
      }
      profile.id = element.objectId;
      this.selectedResource.push({
        name: element.userName,
        startDate: '',
        endDate: new Date(this.endDate),
        resourceType: '',
        userId: profile,
        projectId: project,
        isActive: true,
        status: 'Assigned',
        role: '',
        hours: 0,
        months: 0

      });
    });
    this.resourceForm.reset();
    this.dialog.open(this.projectaddonDialog, {
      width: '1200px'
    });
  }

  /*
  ** ==========================================================
  ** Save Assigned Resource Details
  ** ==========================================================
  */
  saveAssignedResource() {
    var selectedRow = this.selectedRows;
    this.selectedResource = [];
    // this.roleDropChange();
    selectedRow.forEach(element => {
      var profile = new this.parseService.instance.Object('Profile');
      var project = new this.parseService.instance.Object('Project');
      if (this.empRole == 'Admin') {
        project.id = this.objectId;
      }
      if (this.empRole == 'Leader') {
        project.id = this.projectId == undefined ? this.objectId : this.projectId;
      }
      profile.id = element.objectId;
      this.selectedResource.push({
        name: element.userName,
        startDate: element.startDate,
        endDate: new Date(this.endDate),
        resourceType: element.resourceType,
        userId: profile,
        projectId: project,
        hours: element.hours ? element.hours : 0,
        months: element.months ? element.months : 0,
        isActive: true,
        isBillable: element.isBillable,
        status: 'Assigned',
        role: element.role
      });
    });
    this.resourceForm.reset();
    this.addRow();
  }

  async roleDropChange() {
    // let resourcesDetails = this.projetcDetails.get('resourceDetails').details;
    let role = JSON.parse(JSON.stringify(this.roles));
    // this.roles.forEach(element => {
    //   let resourceByRole = this.rowData.filter(x => x.role == element);
    //   let roleCount = resourcesDetails.filter(x => x.role === element);
    //   if (roleCount.length > 0) {
    //     roleCount = roleCount[0].count;
    //   }
    //   if (resourceByRole.length >= roleCount) {
    //     role.splice(role.indexOf(element), 1);
    //   }
    // });
    this.roleOptions = role;
  }


  resourcesPopup() {
    this.selectedRows = [];
    this.getEmployeesProject();
    this.dialog.open(this.projectDialog, {
      width: '1000px',
    });
  }


  /*
  ** ==========================================================
  ** Edit resource
  ** ==========================================================
  */
  editResource(event) {
    this.queryInterface.executeQuery(this.parseService, 'Profile', [
      { condition: 'equalTo', field: 'isActive', value: true },
      { condition: 'include', value: 'location' },
      { condition: 'include', value: 'reportingTo' },
      { condition: 'include', value: 'department' },
      { condition: 'include', value: 'role' },
      { condition: 'ascending', value: 'firstName' },
      { condition: 'limit', value: 1000 },
      { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
      { condition: 'notContainedIn', field: 'objectId', value: this.userIds },
    ]).then(results => {
      this.rowDatas = this.loadResources(results);
      this.userId = event;
      this.queryInterface.executeQuery(this.parseService, 'ProjectMembers', [
        { condition: 'equalTo', field: 'objectId', value: this.userId }]).then(result => {
          var results = result[0];
          var project = new this.parseService.instance.Object('Project');
          if (this.empRole == 'Admin') {
            project.id = this.objectId;
          }
          if (this.empRole == 'Leader') {
            project.id = this.projectId == undefined ? this.objectId : this.projectId;
          }
          this.reAssignResourcePopupForm.patchValue({
            name: results.get('username'),
            startDate: results.get('startDate') ? results.get('startDate') : new Date(),
            endDate: results.get('endDate') ? results.get('endDate') : new Date(),
            resourceType: results.get('resourcesType'),
            isBillable: results.get('isBillable'),
            projectId: project,
            isActive: true,
            status: 'Assigned',
            role: results.get('role'),
            // hours: result.get('Hours') ? result.get('Hours') : 0,
            // months: result.get('Months') ? result.get('Months') : 0

          });
          this.oldReassignValue = JSON.parse(JSON.stringify(this.reAssignResourcePopupForm.value));
          this.dialog.open(this.reAssignResourcePopup);
        });
    }).catch(err => {
      this.sessionHandler.handleParseError(err);
    });
  }

  /*
  ** ==========================================================
  ** Re assign resource
  ** ==========================================================
  */
  reassignResourceSave() {
    this.selectedResource = [];
    let formValue = this.reAssignResourcePopupForm.value;
    this.newValues = this.reAssignResourcePopupForm.value;
    if (this.reAssignResourcePopupForm.value.userId !== null) {
      formValue.name = formValue.userId.userName;
      formValue.userId = formValue.userId.objectId;
      formValue.startDate = this.dateConvertor.addGMTOffset(formValue.startDate);
      formValue.endDate = this.dateConvertor.addGMTOffset(formValue.endDate);
      this.selectedResource.push(formValue);
      this.reassignSave = true;
      this.popupAdd(this.reassignSave);
    }
    else {
      this.toastr.warning('Please Enter all the fields');
    }
  }

  /*
  ** ==========================================================
  ** Activity Model
  ** ==========================================================
  */
  setActivityModel(message): any {
    const createrProfile = this.currentUser.get('profile');
    const createrImg = createrProfile.get('profileImageInfo').url;
    const createrName = createrProfile.get('username');
    const activity = {
      message: message,
      createdBy: createrName,
      createdId: createrProfile.id,
      createdDate: new Date().toUTCString(),
      createrImgUrl: createrImg == undefined ? this.hardCodedValues.defaultProfileImg : createrImg
    };
    return activity;
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

}
